const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid"];

// Kept in memory only (no cookies/storage) – survives SPA navigation.
const attribution = (() => {
  if (typeof window === "undefined") return {};
  const params = new URLSearchParams(window.location.search);
  const data = { landing_page: window.location.pathname + window.location.search, referrer: document.referrer || "" };
  KEYS.forEach((k) => {
    if (params.get(k)) data[k] = params.get(k);
  });
  return data;
})();

export const getAttribution = () => ({ ...attribution, source_page: window.location.pathname });
